import gql from "graphql-tag";

const DELETE_HOMEOWNER_TRAFFIC = gql`
  mutation deleteHomeownerTraffic($input: HomeownerTrafficDeleteInput!) {
    deleteHomeownerTraffic(input: $input) {
      message
      code
    }
  }
`;

export default DELETE_HOMEOWNER_TRAFFIC;
